import { formatDollars } from "@common/components/utils";
import { Body } from "@hypercard/web-components";
import { DataKey } from "./types";

// Types
type DataKeyData = {
  label: string;
  value: number;
  color: string;
};

type Data = Record<DataKey, DataKeyData>;

export type TooltipProps = {
  xAxisLabel: string;
  data: Data;
  hoveredDataKey: DataKey | null;
};

// Component
export const Tooltip = ({ xAxisLabel, data, hoveredDataKey }: TooltipProps) => (
  // TODO: add opacity animation dependent on hoveredDataKey
  <div className="flex min-w-[150px] flex-col space-y-1">
    <div className="rounded border border-[#292929] bg-[#1B1B1B] px-3 py-2">
      <Body size="xs" weight="medium" className="text-center text-[#676767]">
        {xAxisLabel}
      </Body>
    </div>
    <div className="flex flex-col space-y-2 rounded border border-[#292929] bg-[#1B1B1B] px-3 py-2">
      {Object.entries(data).map(([dataKey, { label, value, color }]) => {
        const isHovered = dataKey === hoveredDataKey;
        const showColor = !hoveredDataKey || isHovered;

        return (
          <div className="flex items-center space-x-2" key={dataKey}>
            <div
              className="h-9 w-0.5 rounded-full"
              style={{
                backgroundColor: showColor ? color : "#676767",
              }}
            />
            <div className="space-y-1.5">
              <Body size="xs" weight="medium" className="text-[#676767]">
                {label}
              </Body>
              <Body size="xs" weight="medium">
                {formatDollars(value)}
              </Body>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
